/* STEP 7d — the owner decisions of 30-Oct-2026 10:47 KSA (PR #103): D-b the lead-sheet PY source "prior-year restatement",
   D-c the cash-flow INFO line ("included in operating profit"), J3 with no saved working hours (after-hours test not run),
   and the Clear button of the A9001 working hours. EN + AR.
   Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S7D_OWNER = {
  en: {
    lead: {
      pySource: {
        prior_year_restatement: "Posted prior-year restatement",
      },
    },
    s7do: {
      cf: {
        info: "Information — not a warning and not a check",
      },
      j3: {
        usedNotSet: "Weekend used: {days} · Working hours not set — after-hours test not run",
      },
      hours: {
        clear: "Clear",
        cleared: "Working hours cleared — Not set",
      },
    },
  },
  ar: {
    lead: {
      pySource: {
        prior_year_restatement: "إعادة عرض مرحّلة للسنة السابقة",
      },
    },
    s7do: {
      cf: {
        info: "معلومة — ليست تنبيهاً وليست فحصاً",
      },
      j3: {
        usedNotSet: "العطلة المستخدمة: {days} · ساعات العمل غير محددة — لم يُجرَ اختبار القيود خارج ساعات العمل",
      },
      hours: {
        clear: "مسح",
        cleared: "مُسحت ساعات العمل — غير محددة",
      },
    },
  },
};

export default I18N_S7D_OWNER;
